"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaPlatform = void 0;
var archive_manager_1 = require("../../platform/management/archive-manager");
var av_manager_1 = require("../../platform/management/av-manager");
var file_manager_1 = require("../../platform/management/file-manager");
var flow_manager_1 = require("../../platform/management/flow-manager");
var image_extraction_manager_1 = require("../../platform/management/image-extraction-manager");
var image_manager_1 = require("../../platform/management/image-manager");
var job_manager_1 = require("../../platform/management/job-manager");
var live_manager_1 = require("../../platform/management/live-manager");
var widget_instance_manager_1 = require("../../platform/management/widgets/widget-instance-manager/widget-instance-manager");
var browser_file_downloader_1 = require("./downloader/browser-file-downloader");
var browser_http_client_1 = require("./http/browser-http-client");
var browser_file_uploader_1 = require("./uploader/browser-file-uploader");
var queued_file_uploader_1 = require("./uploader/queued-file-uploader");
var audio_manager_1 = require("../../platform/management/audio-manager");
/**
 * Media Platform Public
 * @param {Configuration} configuration
 * @constructor
 * @doc MediaPlatformPublic
 */
var MediaPlatform = /** @class */ (function () {
    /**
     * constructor
     * @param {Configuration} configuration
     */
    function MediaPlatform(configuration) {
        this.browserHTTPClient = new browser_http_client_1.HTTPClient(configuration.authenticationUrl, configuration.authenticationHeaders);
        var fileUploader = new browser_file_uploader_1.FileUploader(configuration, this.browserHTTPClient);
        var queuedFileUploader = new queued_file_uploader_1.QueuedFileUploader(fileUploader);
        this.fileDownloader = new browser_file_downloader_1.FileDownloader(configuration, this.browserHTTPClient);
        this.archiveManager = new archive_manager_1.ArchiveManager(configuration, this.browserHTTPClient);
        this.fileManager = new file_manager_1.FileManager(configuration, this.browserHTTPClient, fileUploader);
        this.fileManager.queueFileUpload = function (uploadJob) {
            return queuedFileUploader.enqueue(uploadJob);
        };
        this.jobManager = new job_manager_1.JobManager(configuration, this.browserHTTPClient);
        this.audioManager = new audio_manager_1.AudioManager(configuration, this.browserHTTPClient);
        this.avManager = new av_manager_1.AVManager(configuration, this.browserHTTPClient);
        this.liveManager = new live_manager_1.LiveManager(configuration, this.browserHTTPClient);
        this.flowManager = new flow_manager_1.FlowManager(configuration, this.browserHTTPClient);
        this.imageManager = new image_manager_1.ImageManager(configuration, this.browserHTTPClient);
        this.widgetInstancesManager = new widget_instance_manager_1.WidgetInstanceManager(configuration, this.browserHTTPClient);
        this.imageExtractionManager = new image_extraction_manager_1.ImageExtractionManager(configuration, this.browserHTTPClient);
    }
    /**
     * retrieve the auth header for the currently logged in user
     * @returns {Promise<AuthorizationHeader>}
     */
    MediaPlatform.prototype.getAuthorizationHeader = function () {
        var authenticationHeaderPromise = this.browserHTTPClient.getAuthorizationHeader();
        return authenticationHeaderPromise.catch(function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * log out the user
     */
    MediaPlatform.prototype.deauthorize = function () {
        this.browserHTTPClient.deauthorize();
    };
    /**
     * get download url
     * @param {string} path
     * @param {DownloadUrlRequest?} downloadUrlRequest
     * @returns {Promise<DownloadUrl>}
     */
    MediaPlatform.prototype.getDownloadUrl = function (path, downloadUrlRequest) {
        return this.fileDownloader.getDownloadUrl(path, downloadUrlRequest).then(function (response) {
            return response;
        }, function (error) {
            return Promise.reject(error);
        });
    };
    return MediaPlatform;
}());
exports.MediaPlatform = MediaPlatform;
//# sourceMappingURL=media-platform.js.map